import { createFileRoute } from '@tanstack/react-router';

import { DeviceConfigRouteComponent } from '@/pages/utils/DeviceConfigPage.tsx';

import { parseDeviceConfigSearch } from '../../../pages/utils/deviceConfigPage/deviceConfigSearch.ts';

export const Route = createFileRoute('/(app)/utils/deviceConfig')({
  validateSearch: parseDeviceConfigSearch,
  component: DeviceConfigRouteComponent,
});
